import React from 'react'
import ReactMarkdown from 'react-markdown'
import SyntaxHighlighter from 'react-syntax-highlighter'
import style from 'react-syntax-highlighter/dist/cjs/styles/hljs/obsidian'

type MarkdownViewerProps = {
  text: string
}

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ text }) => {
  return (
    <ReactMarkdown
      components={{
        code({ className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '')
          return match ? (
            <Highlighter
              value={String(children).replace(/\n$/, '')}
              language="js"
              {...props}
            />
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          )
        }
      }}
    >
      {text}
    </ReactMarkdown>
  )
}

const Highlighter = ({ value, language }) => {
  if (language === 'js') {
    language = 'javascript'
  }

  return (
    <SyntaxHighlighter
      language={language ?? ''}
      style={style}
      showLineNumbers={true}
    >
      {value ?? ''}
    </SyntaxHighlighter>
  )
}

export default MarkdownViewer
